import React, { useContext, useEffect, useState } from 'react';
import './styles.scss';
import Progress from '../../components/Progress';
import { SetSecondProps } from './interfaces';
import { useTranslation } from 'react-i18next';
import { ScreenEnum } from '../../enums';
import RadioButtons from '../../components/RadioButtons';
import Option from '../../components/Option';
import addParam from '../../utils/addParam';
import { complete } from '../../utils/complete';
import AppStateContext from '../../AppStateProvider/context';

export default function SetSecond(props: SetSecondProps) {
	const { t } = useTranslation();
	const { state, dispatch } = useContext(AppStateContext);
	const completeState = complete(state);
	const [orientation, setOrientation] = useState<string>(
		state.orientation || 'default'
	);
	const [showSecond, setShowSecond] = useState<boolean>(props.showSecond);

	useEffect(() => {
		if (!showSecond) {
			addParam('orientation', null, true);
		}
	}, [showSecond]);

	function handleClick(value: boolean | string) {
		const isToggle = typeof value === 'boolean';

		// SHOW / HIDE SECOND SCREEN

		if (isToggle) {
			const nextShowSecond = value;

			setShowSecond(nextShowSecond);

			if (nextShowSecond && orientation) {
				dispatch({
					type: 'SET_ORIENTATION',
					value: orientation,
				});

				addParam('orientation', orientation, true);
			}

			if (!nextShowSecond) {
				dispatch({
					type: 'SET_ORIENTATION',
					value: null,
				});

				addParam('orientation', null, true);
			}

			return;
		}

		// ORIENTATION CHANGE

		const nextOrientation = value;

		setOrientation(nextOrientation);

		dispatch({
			type: 'SET_ORIENTATION',
			value: nextOrientation || null,
		});

		addParam('orientation', nextOrientation, true);
	}

	return (
		<>
			<div className='top'>
				<div className='set-second'>
					{props.backBtn(ScreenEnum.hardwareCheck)}
					<h1>{t('SetSecondHeadline')}</h1>
					<p className='p1'>{t('SetSecondText')}</p>
					<Progress
						screen={ScreenEnum.setSecond}
						setScreen={props.setScreen}
					/>
					<Option
						selected={showSecond}
						text={t('SetSecondShow')}
						onClick={() => {
							const next = !showSecond;

							setShowSecond(next);

							dispatch({
								type: 'SET_SHOW_SECOND_SCREEN',
								value: next,
							});
						}}
						className='show-second'
						checkMark={true}
					/>
					<RadioButtons
						headline={t('SetSecondRotation')}
						disabled={!showSecond}
						options={[
							{
								selected: orientation === 'default',
								text: '0°',
								value: 'default',
							},
							{
								selected: orientation === 'right',
								text: '90°',
								value: 'right',
							},
							{
								selected: orientation === 'down',
								text: '180°',
								value: 'down',
							},
							{
								selected: orientation === 'left',
								text: '270°',
								value: 'left',
							},
						]}
						onClick={(value: string) => handleClick(value)}
					/>
				</div>
			</div>
			<div className='buttons'>
				<button
					className='white'
					onClick={() =>
						props.setScreen(
							completeState
								? ScreenEnum.final
								: ScreenEnum.softwareCheck
						)
					}
					disabled={!showSecond || orientation === ''}
				>
					{t('SetSecondConfirm')}
				</button>
				<button
					className='black'
					onClick={() => props.setScreen(ScreenEnum.softwareCheck)}
				>
					{t('ButtonSkip')}
				</button>
			</div>
		</>
	);
}
